if (!videos) {
  var videos = document.querySelectorAll('.video--backvideo')
  var videoIntersectionObserver = new IntersectionObserver(videoObserverCallback)
  videos.forEach(function (video) {
    var videoWrapper = video.closest('.video-wrapper')
    var soundcontroller = videoWrapper.querySelector('.soundcontroller')
    var playBtn = videoWrapper.querySelector('.play-btn')
    videoIntersectionObserver.observe(video)

    soundcontroller && soundcontroller.addEventListener('click', manageAudio);
    playBtn && playBtn.addEventListener('click', playVideo);

    if (window.innerWidth < 600 && video.querySelector('source').getAttribute('data-mobile-src')) {
      video.querySelector('source').setAttribute('src', video.querySelector('source').getAttribute('data-mobile-src'))
    }
  })
}

function manageAudio(e) {
  var soundcontroller = e.currentTarget
  var videoWrapper = soundcontroller.closest('.video-wrapper')
  var video = videoWrapper.querySelector('.video--backvideo')
  if (!e.target.closest('.soundcontroller__close')) {
    if (soundcontroller.classList.contains('soundcontroller--off')) {
      video.muted = false
      soundcontroller.classList.remove('soundcontroller--off')
      soundcontroller.classList.add('soundcontroller--on')
    } else {
      video.muted = true
      soundcontroller.classList.remove('soundcontroller--on')
      soundcontroller.classList.add('soundcontroller--off')
    }
  }
  //e.currentTarget.remove()
}

function playVideo(e) {
  var playBtn = e.currentTarget
  var videoWrapper = playBtn.closest('.video-wrapper')
  var video = videoWrapper.querySelector('.video--backvideo')
  video.play()
}

function videoObserverCallback(entries) {
  entries.forEach(function(entry) {
    var video = entry.target
    if (entry.isIntersecting) {
      video.play()
    } else {
      video.pause()
    }
  })
}